import React, { useEffect, useRef, useState } from "react"
import { useParams } from "react-router-dom"
import { useRequest } from '../../hooks/UseRequest'
import { useLeadsWithLoans } from '../../hooks/UseLeadsWithLoans'
import Loading from "../../components/Loading"
import { useSelector, useDispatch } from "react-redux"
import { selectAuth } from "../../redux/authSlice"
import { selectModal, setModal } from "../../redux/modalSlice"
import NoRecord from "../../components/elements/NoRecord"
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import AsyncSelect from 'react-select/async'
import { selectDropdownOptions } from "../../redux/dropdownSlice";
import { setNotification } from "../../redux/notificationSlice"
import NoteItem from "../../components/NoteItem";
import { useForm } from 'react-hook-form';
import { hasUserPermission } from '../../utils/permissionHelper'
import { selectUser } from '../../redux/userSlice'

export default function NoteDashlet() {
  const loadMoreRef = useRef(null);

  const requests = useRequest()
  const requestingNote = useRef(false)
  const params = useParams()
  const auth = useSelector(selectAuth)
  const modal = useSelector(selectModal)
  const dispatch = useDispatch()
  const [showFilter, setShowFilter] = useState(false);
  const [customerTag, setCustomerTag] = useState([])
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedResultCode, setSelectedResultCode] = useState(null)
  const [selectedActivityCode, setSelectedActivityCode] = useState(null)
  const [selectedAgent, setSelectedAgent] = useState(null)
  const [emailFilter, setEmailFilter] = useState(false)
  const [chatFilter, setChatFilter] = useState(false)
  const [voiceFilter, setVoiceFilter] = useState(false)
  const [systemFilter, setSystemFilter] = useState(false)
  const [agentFilter, setAgentFilter] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const { leadData, getLeadsWithLoans } = useLeadsWithLoans()
  const [loanData, setLoanData] = useState(null)
  const [selectedLead, setSelectedLead] = useState(null)
  const [selectedLoan, setSelectedLoan] = useState(null)
  const dropdownOptions = useSelector(selectDropdownOptions);
  const [nextLink, setNextLink] = useState(false)
  const { setValue } = useForm();

  const noteTagType = dropdownOptions.filter((o) => o.code_key === 'tag_type_note')[0]
  const customerTagType = dropdownOptions.filter((o) => o.code_key === 'tag_type_customer')[0]
  const activityCodeType = dropdownOptions.filter((o) => o.code_key === 'tag_type_activity_code')[0]
  const resultCodeType = dropdownOptions.filter((o) => o.code_key === 'tag_type_result_code')[0]

  const [pinnedNotes, setPinnedNotes] = useState([]);

  const [customerNote, setCustomerNote] = useState([]);
  const [loadedNote, setLoadedNote] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [currentFilters, setCurrentFilters] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [pinnedNoteIds, setPinnedNoteIds] = useState([]);
  const [loadingNoteId, setLoadingNoteId] = useState(null);

  const active = useSelector(selectUser)
  const activePermissions = active.spoofed_user.user_permission_options ? active.spoofed_user.user_permission_options : active.data.user_permission_options
  const canEditNote = hasUserPermission(activePermissions, 'can_edit_note')

  const getCustomerNote = async (flag = false, loadMore = false) => {
    requestingNote.current = true;
    setProcessing(true);
    try {
      let endpoint = `${process.env.REACT_APP_API_DOMAIN}/customer/${params.id}/customer_note/search` + (currentFilters ? `?` : "");
      if (nextLink && loadMore) {
        endpoint = nextLink + (currentFilters ? `&` : "");
      }
      if (flag) {
        dispatch(setModal({ is_active: false, options: '' }));
      }
      requests.setEndpoint(endpoint + (currentFilters ? `${currentFilters}` : ""));
      const response = await requests.get();
      requestingNote.current = false;

      const notes = response.data.data;
      const pinnedNotesFromResponse = response.data.pinned_notes;

      setPinnedNoteIds(pinnedNotesFromResponse?.map((note) => note.id));

      setPinnedNotes(pinnedNotesFromResponse);

      if (loadMore) {
        setCustomerNote((prev) => [...prev, ...notes]);
      } else {
        setCustomerNote(notes);
      }

      setLoadedNote(true);
      setNextLink(response.data?.next_page_url);
    } catch (error) {
      requestingNote.current = false;
      dispatch(setNotification({ type: 'error', body: error.response?.data?.message }));
    } finally {
      requestingNote.current = false;
      setProcessing(false);
    }
  };

  const handleThumbtackClick = async (currentNote) => {
    if (isLoading) return;

    setIsLoading(true);
    setLoadingNoteId(currentNote.id);

    try {
      requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/customer_note/${currentNote.id}/pin`);
      await requests.post();
      await getCustomerNote();
    } catch (error) {
      dispatch(setNotification({ type: 'error', body: error.response?.data?.message }));
    } finally {
      setLoadingNoteId(null);
      setIsLoading(false);
    }
  };

  const handleThumbtackUnclick = async (currentNote) => {
    if (isLoading) return;

    setIsLoading(true);
    setLoadingNoteId(currentNote.id);

    try {
      requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/customer_note/${currentNote.id}/unpin`);
      const response = await requests.post();
      const updatedNote = response.data.data;
      currentNote.pinned_date = updatedNote;

      await getCustomerNote();
    } catch (error) {
      dispatch(setNotification({ type: 'error', body: error.response?.data?.message }));
    } finally {
      setLoadingNoteId(null);
      setIsLoading(false);
    }
  };

  const getCustomerTag = async () => {
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/tag`)
    const response = await requests.get()
    setCustomerTag(response.data.data.map((x) => ({ value: x.id, label: x.label, ddo: x.tag_type_dropdown_option_id, relatedTags: x.tag_related_tags.map((item) => item.related_tag_id) })))
    setLoadedNote(true)
  }

  let typingTimeout = null
  const getAgents = async (inputValue, column, operator) => {
    return new Promise((resolve) => {
      if (typingTimeout) clearTimeout(typingTimeout);

      typingTimeout = setTimeout(async () => {
        const filterQuery = {
          and: [
            { column: column, value: inputValue, operator: operator },
          ],
        };

        requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/user?filters=${JSON.stringify(filterQuery)}`);
        const response = await requests.get().then((response) => response.data.data);

        resolve(response);
      }, 1000);
    });
  };

  const parseLabel = ((field) => {
    let option = field.name;
    if (field.label) {
      option = field.label;
    }
    return option
  })

  const parseValue = ((field) => {
    let option = field.id;
    if (field.value) {
      option = field.value;
    }
    return option
  })

  const handleAgentChange = (selectedOption) => {
    setSelectedAgent({ label: selectedOption?.label, value: selectedOption?.id });
    setValue('createdBy', selectedOption?.id);
  };

  useEffect(() => {
    if (auth.fromPageChange && auth.accessToken) {
      getCustomerTag();
      getLeadsWithLoans();
    }
  }, [auth]);

  useEffect(() => {
    if (auth.accessToken && auth.fromPageChange) {
      if (!requestingNote.current) {
        requestingNote.current = true
        if (currentFilters == null) {
          getCustomerNote(false);
        } else {
          getCustomerNote()
        }
      }
    }
  }, [auth, currentFilters])

  if (modal.options?.refresh === 'NOTE_DASHLET') {
    if (auth.accessToken) {
      requestingNote.current = true
      getCustomerNote('added_new_note')
    }
  }

  const filterNotes = () => {
    const selectedTagsArray = selectedTags.map((tag) => tag.value);
    let customerNoteFilters = [];
    selectedTagsArray.forEach((tag) => {
      customerNoteFilters.push(`tag_id[]=${tag}`)
    })
    if (selectedActivityCode) {
      customerNoteFilters.push(`activity_code_tag_id=${JSON.stringify(selectedActivityCode.value)}`)
    }
    if (selectedResultCode) {
      customerNoteFilters.push(`result_code_tag_id=${JSON.stringify(selectedResultCode.value)}`)
    }
    if (selectedAgent?.value) {
      customerNoteFilters.push(`agent_id=${selectedAgent.value}`)
    }
    if (emailFilter) {
      customerNoteFilters.push(`is_email=1`)
    }
    if (chatFilter) {
      customerNoteFilters.push(`is_chat=1`)
    }
    if (voiceFilter) {
      customerNoteFilters.push(`is_voice=1`)
    }
    if (systemFilter) {
      customerNoteFilters.push(`is_system=1`)
    }
    if (agentFilter) {
      customerNoteFilters.push(`is_agent=1`)
    }
    if (selectedLead) {
      customerNoteFilters.push(`lead_id=${selectedLead.value}`)
    }
    if (selectedLoan) {
      customerNoteFilters.push(`loan_id=${selectedLoan.value}`)
    }
    if (startDate) {
      customerNoteFilters.push(`start_date=${startDate}`)
    }
    if (endDate) {
      customerNoteFilters.push(`end_date=${endDate}`)
    }
    setCurrentFilters(customerNoteFilters && customerNoteFilters.join('&'))
  }

  const clearNotesFilter = () => {
    setSelectedTags([]);
    setSelectedResultCode(null);
    setSelectedActivityCode(null);
    setSelectedAgent(null);
    setValue('createdBy', null);
    setEmailFilter(false);
    setChatFilter(false);
    setVoiceFilter(false);
    setSystemFilter(false);
    setAgentFilter(false);
    setSelectedLead(null);
    setSelectedLoan(null);
    setLoanData(null);
    setStartDate('');
    setEndDate('');
    setCurrentFilters(null);
  }

  // IntersectionObserver useEffect:
  useEffect(() => {
    if (!nextLink || processing || isLoading) return;
    const observer = new window.IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          getCustomerNote(false, true); // Fetch next page
        }
      },
      { threshold: 1.0 }
    );
    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }
    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [nextLink, processing, isLoading]);

  return (
    <div className="message is-white lox-dashlet-detail mt-1">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Note History </p>
        <span onClick={() => { setShowFilter(!showFilter) }} className="is-flex" style={{ alignItems: 'center' }}><span className="mr-2">Filter</span>
          {showFilter ?
            <FontAwesomeIcon icon={faCaretDown} className="is-size-4" /> :
            <FontAwesomeIcon icon={faCaretRight} className="is-size-4" />}
        </span>
      </div>
      {showFilter && customerTag ? (
        <div>
          <div>
            <div className="p-2">
              <div className="has-text-grey formLabel">
                Activity Code
              </div>
              <Select
                name="activityCode"
                options={customerTag.filter((x) => x.ddo === activityCodeType.id)}
                value={selectedActivityCode}
                onChange={(e) => setSelectedActivityCode(e)}
                placeholder="Search a Activity Code"
                styles={{ menu: (provided) => ({ ...provided, zIndex: 100 }) }}
                isClearable
              />
            </div>

            <div className="p-2">
              <div className="has-text-grey formLabel">
                Disposition
              </div>
              <Select
                name="resultCode"
                options={customerTag.filter((x) => x.ddo === resultCodeType.id)}
                value={selectedResultCode}
                onChange={(e) => setSelectedResultCode(e)}
                placeholder="Search a Disposition"
                styles={{ menu: (provided) => ({ ...provided, zIndex: 100 }) }}
                isClearable
              />
            </div>
            <div className="p-2">
              <div className="has-text-grey formLabel">
                Tags
              </div>
              <Select
                isMulti
                name="tags"
                options={customerTag.filter((x) => x.ddo === noteTagType.id || x.ddo === customerTagType.id)}
                value={selectedTags}
                onChange={(e) => setSelectedTags(e)}
                placeholder="Search Tags ..."
                styles={{ menu: (provided) => ({ ...provided, zIndex: 100 }) }}
                isClearable
              />
            </div>
            <div className="p-2">
              <div className="has-text-grey formLabel">
                Agent
              </div>
              <AsyncSelect
                isSearchable
                onChange={handleAgentChange}
                value={selectedAgent}
                isClearable
                cacheOptions
                defaultOptions={false}
                placeholder="Search for an Agent ..."
                loadOptions={(inputValue) => getAgents(inputValue, 'label', 'like')}
                getOptionLabel={(e) => parseLabel(e)}
                getOptionValue={(e) => parseValue(e)}
                noOptionsMessage={({ inputValue }) => (!inputValue ? 'Start typing to search...' : 'No results found')}
                styles={{ menu: (provided) => ({ ...provided, zIndex: 100 }) }}
              />
            </div>
            <div className="p-2">
              <div className="has-text-grey formLabel">
                Lead
              </div>
              <div data-testid="note-dashlet-lead-select">
                <Select
                  name="lead_id"
                  isClearable
                  isLoading={leadData === null}
                  options={leadData ?? []}
                  value={selectedLead}
                  onChange={(e) => {
                    setSelectedLead(e)
                    setSelectedLoan(null)
                    setLoanData(e?.loans ?? [])
                  }}
                  placeholder="Search a Lead"
                  styles={{ menu: (provided) => ({ ...provided, zIndex: 100 }) }}
                />
              </div>
            </div>
            <div className="p-2">
              <div className="has-text-grey formLabel">
                Loan
              </div>
              <div data-testid="note-dashlet-loan-select">
                <Select
                  name="loan_id"
                  isClearable
                  options={loanData ?? []}
                  value={selectedLoan}
                  isDisabled={!selectedLead}
                  onChange={(e) => setSelectedLoan(e)}
                  placeholder="Search a Loan"
                  styles={{ menu: (provided) => ({ ...provided, zIndex: 100 }) }}
                />
              </div>
            </div>
            <div className="px-2 py-2 mb-0 is-flex">
              <div className="mr-2">
                <div className="has-text-grey formLabel">
                  Start Date
                </div>
                <input
                  type="date"
                  className="input is-small"
                  data-testid="note-dashlet-start-date"
                  value={startDate}
                  max={endDate || undefined}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div>
                <div className="has-text-grey formLabel">
                  End Date
                </div>
                <input
                  type="date"
                  className="input is-small"
                  data-testid="note-dashlet-end-date"
                  value={endDate}
                  min={startDate || undefined}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
            <div className="px-4 py-2 mb-0 columns">

              <div className="p-2 pr-1">
                <label className="has-text-grey pr-1 formLabel">
                  Email
                </label>
                <input
                  checked={emailFilter}
                  onChange={(val) => {
                    setEmailFilter(!emailFilter)
                  }}
                  type="checkbox"
                />
              </div>
              <div className="p-2 pr-1">
                <label className="has-text-grey pr-1 formLabel">
                  Chat
                </label>
                <input
                  checked={chatFilter}
                  onChange={(val) => {
                    setChatFilter(!chatFilter)
                  }}
                  type="checkbox"
                />
              </div>
              <div className="p-2 pr-1">
                <label className="has-text-grey pr-1 formLabel">
                  Voice
                </label>
                <input
                  checked={voiceFilter}
                  onChange={(val) => {
                    setVoiceFilter(!voiceFilter)
                  }}
                  type="checkbox"
                />
              </div>
              <div className="p-2 pr-1">
                <label className="has-text-grey pr-1 formLabel">
                  System
                </label>
                <input
                  checked={systemFilter}
                  onChange={(val) => {
                    setSystemFilter(!systemFilter)
                  }}
                  type="checkbox"
                />
              </div>
              <div className="p-2 pr-1">
                <label className="has-text-grey pr-1 formLabel">
                  Agent
                </label>
                <input
                  checked={agentFilter}
                  onChange={(val) => {
                    setAgentFilter(!agentFilter)
                  }}
                  type="checkbox"
                />
              </div>
            </div>
            <div className="is-flex is-justify-content-end pr-2 pb-2">
              <button
                type="button"
                className="button has-background-grey has-text-white px-4"
                onClick={clearNotesFilter}
                disabled={processing}
              >{processing ? <Loading size="is-size-6" /> : 'Clear'}
              </button>
              <button
                type="button"
                className="button is-link has-text-white header-button px-4"
                onClick={filterNotes}
                disabled={processing}
              >{processing ? <Loading size="is-size-6" /> : 'Apply'}
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {!loadedNote && <Loading />}
      {loadedNote && customerNote.length === 0 && pinnedNotes.length === 0 && <NoRecord />}
      {pinnedNotes.length > 0 && (
        <div className="pinned-note-border">
          {pinnedNotes.map((note, index) => (
            <NoteItem
              key={`pinned-${note.id}`}
              note={note}
              isPinned
              handleClick={handleThumbtackUnclick}
              isLoading={loadingNoteId === note.id}
              canEditNote={canEditNote}
            />
          ))}
        </div>
      )}
      {loadedNote && customerNote && customerNote.length > 0 && customerNote.map((note, index) => (
        !pinnedNoteIds.includes(note.id) ? (
          <NoteItem
            key={note.id}
            note={note}
            handleClick={handleThumbtackClick}
            isLoading={loadingNoteId === note.id}
            canEditNote={canEditNote}
          />
        ) : null
      ))}
      {nextLink && <div ref={loadMoreRef} style={{ height: '1px' }}></div>}
      {nextLink && (
        <div className="column columns is-full is-flex is-justify-content-space-between is-align-items-flex-start pl-3 pt-0 m-0">
          {processing || isLoading ? <Loading size="is-size-6" /> : null}
        </div>
      )}
      {/* {nextLink && (
        <div className="column columns is-full is-flex is-justify-content-space-between is-align-items-flex-start pl-3 pt-0 m-0">
          {processing || isLoading ? <span>Loading ...</span> : (
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault()
                getCustomerNote(false, true)
              }}
              className="is-size-7 has-text-link"
            >
              Load more ...
            </a>
          )}
        </div>
      )} */}
    </div>
  );
}
